import React from 'react';

import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Table from '@zg-rentals/multibrand-ui/lib/Table';

import './style.scss';

const AMENITIES = {
    LAUNDRY: 'Laundry',
    PETS: 'Pets',
    GYM: 'Gym',
    PARKING: 'Parking',
    POOL: 'Pool',
};

const CompetitorTable = ({ properties }) => {
    const selectedListing = properties[0];
    const competitors = properties.slice(1, 4);

    const populateTable = amenity => (
        <Table.Row className="Body">
            <Table.Col className="ColumnOne">
                <Text emphasize={true}>{amenity}</Text>
            </Table.Col>
            <Table.Col className="UserPropertyColumn">
                {selectedListing.amenities[amenity.toLowerCase()]
                    ? selectedListing.amenities[amenity.toLowerCase()]
                    : 'Not Listed'}
            </Table.Col>
            {competitors.map((competitor, id) => (
                <Table.Col className="CompetitorColumn" key={id}>
                    {competitor.amenities[amenity.toLowerCase()]
                        ? competitor.amenities[amenity.toLowerCase()]
                        : 'Not Listed'}
                </Table.Col>
            ))}
        </Table.Row>
    );

    return (
        <Table isExpandable={false}>
            <Table.Row className="Header">
                <Table.Col className="ColumnOne">
                    <Text className="TextStyle" emphasize={true}>
                        Properties
                    </Text>
                </Table.Col>
                <Table.Col className="UserPropertyHeader">
                    <Text className="TextStyle" emphasize={true}>
                        Your Property
                    </Text>
                </Table.Col>
                {competitors.map((competitor, i) => (i === 0
                    ? (
                        <Table.Col className="TopCompetitorHeader">
                            <Text className="TextStyle" emphasize={true}>
                                Top Competitors
                            </Text>
                        </Table.Col>
                    ) : (
                        <Table.Col className="TopCompetitorHeader" />
                    )
                ))}
            </Table.Row>
            <Table.Row className="Body">
                <Table.Col className="ColumnOne" />
                <Table.Col className="UserPropertyColumn">
                    <Text className="UserPropertyName" emphasize={true}>
                        {selectedListing.name}
                    </Text>
                </Table.Col>
                {competitors.map((competitor, id) => (
                    <Table.Col className="CompetitorColumn" key={id}>
                        <Text className="CompetitorPropertyName" emphasize={true}>
                            {competitor.name}
                        </Text>
                    </Table.Col>
                ))}
            </Table.Row>
            <Table.Row className="Header">
                <Table.Col className="ColumnOne">
                    <Text className="TextStyle" emphasize={true}>
                        Amenities
                    </Text>
                </Table.Col>
                {competitors.map(() => <Table.Col />)}
            </Table.Row>
            {populateTable(AMENITIES.LAUNDRY)}
            {populateTable(AMENITIES.PARKING)}
            {populateTable(AMENITIES.PETS)}
            {populateTable(AMENITIES.GYM)}
            {populateTable(AMENITIES.POOL)}
        </Table>
    );
};

export default CompetitorTable;
